export const LOGIN_MENU = [
  {
    text: '로그인',
    name: 'login',
    show: false,
  },
  {
    text: '로그아웃',
    name: 'logout',
    show: true,
  },
];

export const AUTH_HEADER_MENU = [
  {
    text: '마이페이지',
    name: 'myPage',
    link: '/my',
  },
  {
    text: '북마크',
    name: 'bookmark',
    link: '/bookmark',
  },
];

export const MY_PAGE_MENU = [
  {
    text: '내 정보',
    link: '/my',
  },
  // {
  //   text: '내 오픈 플레이',
  //   link: '/my/play',
  // },
];
